import { makeStyles } from '@material-ui/core/styles'
export const useStyles = makeStyles((theme) => ({
    fullWidth: {
        width: '100%',
        fontSize: '0.875rem'
    },
    paper: {
        padding: 16,
        border: '1px solid #ebe4e4',
        borderRadius : '20px'
    },
    languagesContainer: {
        padding: 24,
        [theme.breakpoints.down('sm')]: {
            padding: '24px 8px'
        }
    },
    gridFlex: {
        display: 'flex',
        justifyContent: 'flex-start',
        textAlign: 'end'
    },
    formControl: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    isEmpty: {
        color: 'var(--red)'
    },
    datePicker: {
        color: 'white',
        textColor: 'white',
        calendarTextColor: 'white',
        selectColor: 'white',
        selectTextColor: 'white',
        calendarYearBackgroundColor: 'white',
        headerColor: 'white'
    },
    iconColor: {
    },
    textFont: {
        fontSize: '0.875rem'
    },
    languageContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    star: {
        color: 'var(--background-yellow)',
        stroke: 'black',
        strokeWidth: '30px'

    },
    button: {
        backgroundColor: 'var(--background-purple)',
        color: 'white',
        fontFamily: 'GreedStandard-Light',
        padding: '20px 20px'
    },
    aiHighlight: {
        height: '80%',
        paddingLeft: '10px',
        borderLeft: '2px solid var(--background-purple)'
    },
    simpleChip: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontFamily: "'GreedStandard-Medium', sans-serif",
        color: 'black',
        borderRadius: '50',
        boxSizing: 'border-box',
        border: 'solid white 1px',
        padding: '15px 0px 15px 10px',
        backgroundColor: `${theme.palette.bg.greyLight}`,
        marginBottom: 4,
        width: 'fit-content',
        cursor: 'pointer',
        fontSize: '14px',
        '&:hover': {
            boxShadow: `1px 2px 0px 0px ${theme.palette.bg.black}`
        }
    },
    badgeDelete: {
        marginLeft: '15px',
        color: 'black',
        '&:hover': {
            color: 'black'
        }
    },
    textInputContainer: {
        width: '100%',
        height: '35px',
        padding: '0px 14px',
        border: `1px solid ${theme.palette.fg.black}`,
        backgroundColor: theme.palette.bg.white,
        borderRadius: '80px',
        display: 'flex',
        alignItems: 'center',
        columnGap: '5px',
        transition: 'box-shadow 0.3s ease-in-out',
        '&:hover': {
            boxShadow: `4px 4px 0px 0px ${theme.palette.bg.black}`
        }
    },
    searchResults: {
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
        maxHeight: 'calc(5 * 40px)',
        overflowY: 'auto',
        marginTop: '5px',
        border: `1px solid ${theme.palette.fg.black}`,
        backgroundColor: theme.palette.bg.white,
        borderRadius: '20px',
        alignItems: 'left',
        fontFamily: 'GreedStandard-Light'
    },
    searchIcon: {
        color: 'black',
        width: '20px'
    },
    closed: {
        display: 'none'
    },
    emptyList: {
        position: 'relative',
        top: '10px',
        color: `${theme.palette.fg.greySlate}`,
    },
    max3: {
        color: theme.palette.error.main
    }
}))
